<article *ngIf="showCarrousel" class="w-full flex flex-column fadein animation-duration-1000 gap-0 pt-0 ">
  <section class="w-full">
    <app-video-carrousel [selectedVideo]="selectedVideo"></app-video-carrousel>
  </section>

  <main class="ci-panel ci-panel__body-gap w-full flex justify-content-between">
    <ng-container *ngFor="let item of panel?.lanes, index as i">
      <section class="w-full">
        <div *ngIf="showLane" class="ci-panel__body-item ci-panel__body-main-direction ci-panel__body-main-direction-carrousel">
          <div>
            {{item?.name}}
          </div>

          <div class="ci-panel__body-main-direction-arrow" [ngClass]="{'ci-panel__body-main-direction-arrow--left': item.orientation === 'Izquierda',
                                   'ci-panel__body-main-direction-arrow--right': item.orientation === 'Derecha'}">
            <img src="assets/images/mv-arrow.png" alt="Direction arrow">
          </div>
        </div>
      </section>

      <div *ngIf="i < panel?.lanes.length - 1" class="ci-panel__body-item-border">
      </div>
    </ng-container>
  </main>
</article>

<article *ngIf="panel?.active" class="ci-panel w-full flex flex-column fadein animation-duration-1000"
         [ngClass]="{'ci-min-panel': !showLane, 'visibility': showCarrousel}">
  <header class="w-full flex align-items-center justify-content-between">
    <section class="ci-panel__message ci-panel__marquee-container">
      <app-message [slug]="slug"></app-message>
    </section>

    <section class="ci-panel__time">
      <app-weather-time *ngIf="panel.origin" [coords]="getLocationCoords(panel.origin)">
      </app-weather-time>
    </section>

    <section class="ci-panel__brand flex justify-content-center align-items-start">
      <img src="assets/images/logo/somosinno.png" alt="Somos innovación">
    </section>
  </header>

  <main class="ci-panel__body-gap w-full flex justify-content-between">
    <ng-container *ngFor="let item of panel?.lanes, index as i">
      <section class="w-full">
        <div *ngFor="let destination of item.routes" class="ci-panel__body-item ci-panel__body-indication">
          <div class="w-8 white-space-nowrap overflow-hidden flex text-overflow-ellipsis">
            {{destination.title}}
          </div>

          <div *ngIf="!showDistance && destination.details[0]?.duration"
            class="w-5 fadein animation-duration-1000 flex justify-content-end align-items-center overflow-hidden"
            [ngClass]="{'ci-min-panel__data': !showLane}">
            <i class="hidden md:block bi bi-car-front ci-txt--white"></i>

            <small class="flex bg-black-alpha-10 px-1 border-round font-normal">
              {{getMinutes(destination.details[0]?.duration_in_traffic)}}
              <div class="flex align-items-center justify-content-center font-light">
                <span class="ci-txt--yellow-traffic"> min </span>
              </div>
            </small>
          </div>

          <div *ngIf="showDistance && destination.details[0]?.distance"
            class="w-4 fadein animation-duration-1000 flex justify-content-end align-items-center"
            [ngClass]="{'ci-min-panel__data': !showLane}">
            <i class="hidden md:block bi bi-car-front ci-txt--white"></i>

            <small class="font-normal flex bg-black-alpha-10 px-2 border-round align-items-end">
              {{getKilometers(destination.details[0]?.distance)}} <p class="ci-txt--yellow-traffic font-light">Km</p>
            </small>
          </div>
        </div>

        <div *ngIf="showLane" class="ci-panel__body-item ci-panel__body-main-direction">
          <div>
            {{item?.name}}
          </div>

          <div class="ci-panel__body-main-direction-arrow" [ngClass]="{'ci-panel__body-main-direction-arrow--left': item.orientation === 'Izquierda',
                             'ci-panel__body-main-direction-arrow--right': item.orientation === 'Derecha'}">
            <img src="assets/images/mv-arrow.png" alt="Direction arrow">
          </div>
        </div>
      </section>

      <div *ngIf="i < panel?.lanes.length - 1" class="ci-panel__body-item-border">
      </div>
    </ng-container>
  </main>
</article>

<style>
  .hidden {
    display: none !important;
  }
  .visibility {
    visibility: hidden !important;
  }
</style>